import * as widgetTypes from 'modules/dashboard/utils/dashboardWidgetTypes';
import { createObjectWithKey, createDropdownOption } from 'utils/helpers';
import { CampaignsTableWidget } from './CampaignsTableWidget';
import MarkdownWidget from './MarkdownWidget';
import MetricWidget from './MetricWidget';

/** Dropdown options of widget types */
export const widgetTypeOptions = [
  createDropdownOption(widgetTypes.METRIC, 'Metric'),
  createDropdownOption(widgetTypes.CAMPAIGNS_TABLE, 'Campaigns Table'),
  createDropdownOption(widgetTypes.MARKDOWN, 'Markdown'),
];

/** Object definition of widget type matching to corresponding widget component. */
const widgetDef = {
  ...createObjectWithKey(widgetTypes.METRIC, MetricWidget),
  ...createObjectWithKey(widgetTypes.CAMPAIGNS_TABLE, CampaignsTableWidget),
  ...createObjectWithKey(widgetTypes.MARKDOWN, MarkdownWidget),
};

export const getWidgetComponentFromType = (widgetType) => widgetDef[widgetType] || MetricWidget;
